import { render, staticRenderFns } from "./visitors.vue?vue&type=template&id=2c8b6f16"
import script from "./visitors.vue?vue&type=script&lang=js"
export * from "./visitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports